
import DrawBase from "../DrawBase"
import EditBezier from "./EditBezier"
import { cartesians2lonlats, lonlats2cartesians } from "../../utils/CoordinateUtil.js"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawBezier extends DrawBase {

    constructor(options) {
        super(options);
    }

    getEditInterface() {
        return EditBezier;
    }

    getTypeName() {
        return "曲线";
    }
    getType() {
        return "bezier_Nor";
    }

    calculateKeyPositions() {

        this.positions = this.positionsTemp;
        if (this.positionsTemp.length < 2) {
            return;
        }
        var line = turf.lineString(this.cart2Wgs84(this.positionsTemp));
        var curved = turf.bezierSpline(line);
        var coordinates = curved.geometry.coordinates;
        return lonlats2cartesians(coordinates);
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions=[];
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            positions= $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = positions.slice();
                return positionsArr;
            }
            return positionsArr ? positionsArr : positions;
        }, false);

        var polyline = this.createPolyline(positionsProperty);
        entity.polyline = polyline;
    }

    loadDynamicGraph(entity, data) {

        var $this = this;
        var positionsArr = JSON.parse(data.editPositions);
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            var line = turf.lineString($this.cart2Wgs84(positionsArr));
            var curved = turf.bezierSpline(line);
            var coordinates = curved.geometry.coordinates;
            return lonlats2cartesians(coordinates);
        }, true);

        var polyline = this.createPolyline(positionsProperty);
        entity.polyline = polyline;

        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polyline")

    }
}

export default DrawBezier